export default {
    data() {
        return {
            integrationPlatforms: [
                { text: 'Discogs', value: 'discogs' },
                { text: 'Amazon', value: 'amazon' },
                { text: 'Amazon UK', value: 'amazon-uk' },
            ]
        }
    }
}